(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Member', Member);

    Member.$inject = ['$resource', 'urls', 'httpMethods'];
    function Member($resource, urls, httpMethods) {
        return $resource('', { id: '@id' }, {
            getSnapshot: { url: urls.memberSnapshot, method: httpMethods.get },
            getFriends: { url: urls.getFriends, method: httpMethods.get, isArray: true },
            addFriend: { url: urls.addFriend, method: httpMethods.post },
            removeFriend: { url: urls.removeFriend, method: httpMethods.post },
            search: { url: urls.memberSearch, method: httpMethods.get, allowAnonymous: true },
            getSettings: { url: urls.getSettings, method: httpMethods.get },
            saveSettings: { url: urls.saveSettings, method: httpMethods.post },
            changePassword: { url: urls.changePassword, method: httpMethods.post },
            saveHomeCourseAndTee: { url: urls.saveHomeCourseAndTee, method: httpMethods.post },
            requestCard: { url: urls.requestCard, method: httpMethods.post },
            cancelSubscription: { url: urls.cancelSubscription, method: httpMethods.post },
            getBadges: { url: urls.getBadges, method: httpMethods.get },
            renewOrUpgrade: { url: urls.renewOrUpgrade, method: httpMethods.post },
            removeMembers: { url: urls.removeMembers, method: httpMethods.post },
            setStatus: { url: urls.setStatus, method: httpMethods.post },
            getDetails: { url: urls.getDetails, method: httpMethods.get },
            addMember: { url: urls.addMember, method: httpMethods.post },
            resetPendingStatus: { url: urls.resetPendingStatus, method: httpMethods.post },
            getProfile: { url: urls.getProfile, method: httpMethods.get },
            sendPasswordEmail: { url: urls.sendPasswordEmail, method: httpMethods.post },
            calculateHandicap: { url: urls.calculateHandicap, method: httpMethods.post },
            sendScoresToUSGA: { url: urls.sendScoresToUSGA, method: httpMethods.post },
            calculateLowHandicap: { url: urls.calculateLowHandicap, method: httpMethods.post },
            reverseActivation: { url: urls.reverseActivation, method: httpMethods.post },
            adminSearch: { url: urls.adminSearch, method: httpMethods.get },
            saveEmail: { url: urls.saveEmail, method: httpMethods.post },
            getIgnMemberships: { url: urls.getIgnMemberships, method: httpMethods.get, isArray: true },
            saveIgnMembership: { url: urls.saveIgnMembership, method: httpMethods.post },
            deleteIgnMembership: { url: urls.deleteIgnMembership, method: httpMethods.post },
            getModifiedHandicap: { url: urls.getModifiedHandicap, method: httpMethods.get },
            saveModifiedHandicap: { url: urls.saveModifiedHandicap, method: httpMethods.post },
            saveScoreAdjustment: { url: urls.saveScoreAdjustment, method: httpMethods.post },

            getIntegrations: { url: urls.getIntegrations, method: httpMethods.get, isArray: true },
            saveIntegration: { url: urls.saveIntegration, method: httpMethods.post },
            deleteIntegration: { url: urls.deleteIntegration, method: httpMethods.post },

            getAttributes: { url: urls.getAttributes, method: httpMethods.get, isArray: true },
            saveAttribute: { url: urls.saveAttribute, method: httpMethods.post },
            deleteAttribute: { url: urls.deleteAttribute, method: httpMethods.post },


            getRoles: { url: urls.getRoles, method: httpMethods.get, isArray: true },
            saveRole: { url: urls.saveRole, method: httpMethods.post },
            deleteRole: { url: urls.deleteRole, method: httpMethods.post },

            getMemberships: { url: urls.getMemberships, method: httpMethods.get, isArray: true },
            saveMembership: { url: urls.saveMembership, method: httpMethods.post },
            restoreArchivedMembership: { url: urls.restoreArchivedMembership , method: httpMethods.post },

            mergeAccounts: { url: urls.mergeAccounts, method: httpMethods.post },
            sendEmail: { url: urls.sendEmail, method: httpMethods.post },

            requestTransfer: { url: urls.requestTransfer, method: httpMethods.post },

            getCourseList: { url: urls.getCourseList, method: httpMethods.get, isArray: true },
            addToCourseList: { url: urls.addToCourseList, method: httpMethods.post },
            removeFromCourseList: { url: urls.removeFromCourseList, method: httpMethods.post },
            getHandicapHistory: { url: urls.getHandicapHistory, method: httpMethods.get, isArray: true },            

            // These probably don't belong here.
            getActivities: { url: urls.getActivities, method: httpMethods.get, params: { individualId: '@individualId' } },
            saveActivity: { url: urls.saveActivity, method: httpMethods.post, params: { individualId: '@individualId' } },
            removeActivity: { url: urls.removeActivity, method: httpMethods.post, params: { individualId: '@individualId' } },
            checkInRBCCanadianOpenPlayer: { url: urls.checkInRBCCanadianOpenPlayer, method: httpMethods.post },
            convertNineToEighteen: { url: urls.convertNineToEighteen, method: httpMethods.post }
        });
    }
})();